'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormatter } from 'next-intl';
import { ReviewsCardProps } from '@/types/trustpilot';
const ReviewsCard: React.FC<ReviewsCardProps> = t0 => {
  const $ = _c(23);
  const {
    title,
    text,
    consumer,
    createdAt,
    id
  } = t0;
  const format = useFormatter();
  let t1;
  if ($[0] !== format) {
    t1 = date => format.relativeTime(date, new Date());
    $[0] = format;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formatTimeAgo = t1;
  let t2;
  if ($[2] !== title) {
    t2 = <h4 className="mb-2 text-sm font-medium">{title}</h4>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== text) {
    t3 = <p className="line-clamp-6 overflow-hidden text-sm text-ellipsis">{text}</p>;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="mb-2">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = consumer?.displayName;
  let t6;
  if ($[9] !== t5) {
    t6 = <p className="text-sm">{t5}</p>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== createdAt || $[12] !== formatTimeAgo) {
    t7 = formatTimeAgo(new Date(createdAt));
    $[11] = createdAt;
    $[12] = formatTimeAgo;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <p className="text-sm text-neutral-700">{t7}</p>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div>{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== id || $[20] !== t4 || $[21] !== t9) {
    t10 = <div className="mx-auto h-64 max-w-2xs pl-4" key={id}>{t4}{t9}</div>;
    $[19] = id;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default ReviewsCard;